module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "默认"
    },
    on: {
      "click": function($event) {
        _vm.showToast(1)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "中部"
    },
    on: {
      "click": function($event) {
        _vm.showToast(2)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "顶部"
    },
    on: {
      "click": function($event) {
        _vm.showToast(3)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "底部"
    },
    on: {
      "click": function($event) {
        _vm.showToast(4)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "警告"
    },
    on: {
      "click": function($event) {
        _vm.showToast(5)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": function($event) {
        _vm.showToast(6)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "1s消失"
    },
    on: {
      "click": function($event) {
        _vm.showToast(7)
      }
    }
  }), _vm._v(" "), _c('Toast', {
    attrs: {
      "show": _vm.toast.show,
      "position": _vm.toast.position,
      "type": _vm.toast.type,
      "time": _vm.toast.time,
      "msg": _vm.toast.msg
    },
    on: {
      "toast-hide": _vm.toastHide
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-e1816784"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Toast.vue
// module id = 82
// module chunks = 1